import { actionCreator, locales } from 'utils';
import * as LayoutTypes from '../types/layoutTypes';

const userLang = navigator.language || navigator.userLanguage;
let userSliceLang = userLang.slice(0, 2);

if (!locales.includes(userSliceLang)) {
    userSliceLang = 'en';
}

const initState = {
    admin: '',
    menuCollapsed: false,
    menuMobile: false,
    locale: userSliceLang,
    planningNavigationDate: null,
    reseller: {
        loading: false,
        error: false,
        data: null,
    },
    userToken: {
        loading: false,
        error: false,
        data: null,
    },
    userData: {
        loading: false,
        error: false,
        data: null,
        operator: null,
    },
    userPermissions: null,
    partners: {},
    resellers: {},
    search: {
        tab: null,
        counts: {
            orders: null,
            orderItems: null,
            billingAccounts: null,
            invoices: null,
            customers: null,
        },
    },
    translationResellerId: undefined,
};

export default function (state = initState, action) {
    switch (action.type) {
    case LayoutTypes.SET_ADMIN:
        return Object.assign({}, state, {
            admin: action.admin,
        });

    case LayoutTypes.TOGGLE_COLLAPSING_MENU:
        return Object.assign({}, state, {
            menuCollapsed: !state.menuCollapsed,
        });

    case LayoutTypes.TOGGLE_MOBILE_MENU:
        return Object.assign({}, state, {
            menuMobile: !state.menuMobile,
        });

    case LayoutTypes.SWITCH_LOCALE:
        return Object.assign({}, state, {
            locale: action.locale,
        });

    case LayoutTypes.EDIT_RESELLER_PROFILE:
        return Object.assign({}, state, {
            reseller: {
                ...state.reseller,
                loading: true,
                error: false,
            },
        });

    case actionCreator(LayoutTypes.EDIT_RESELLER_PROFILE, 'res'):
        return Object.assign({}, state, {
            reseller: {
                ...state.reseller,
                loading: false,
                error: false,
            },
        });

    case actionCreator(LayoutTypes.EDIT_RESELLER_PROFILE, 'err'):
        return Object.assign({}, state, {
            reseller: {
                ...state.reseller,
                loading: false,
                error: true,
            },
        });

    case LayoutTypes.LOAD_RESELLER:
        return Object.assign({}, state, {
            reseller: {
                ...state.reseller,
                loading: true,
                error: false,
            },
        });

    case actionCreator(LayoutTypes.LOAD_RESELLER, 'res'):
        return Object.assign({}, state, {
            reseller: {
                ...state.reseller,
                loading: false,
                data: action.data,
            },
        });

    case actionCreator(LayoutTypes.LOAD_RESELLER, 'err'):
        return Object.assign({}, state, {
            reseller: {
                ...state.reseller,
                loading: false,
                error: true,
            },
        });

    case LayoutTypes.USER_LOGIN:
        return Object.assign({}, state, {
            userToken: {
                ...state.userToken,
                loading: true,
                error: false,
            },
        });

    case actionCreator(LayoutTypes.USER_LOGIN, 'res'):
        return Object.assign({}, state, {
            userToken: {
                ...state.userToken,
                loading: false,
                data: action.data,
            },
        });

    case actionCreator(LayoutTypes.USER_LOGIN, 'err'):
        return Object.assign({}, state, {
            userToken: {
                ...state.userToken,
                loading: false,
                error: true,
            },
        });

    case LayoutTypes.GET_USER_DATA:
        return Object.assign({}, state, {
            userData: {
                ...state.userData,
                loading: true,
                error: false,
            },
        });

    case actionCreator(LayoutTypes.GET_USER_DATA, 'res'):
        return Object.assign({}, state, {
            userData: {
                ...state.userData,
                loading: false,
                data: action.data,
            },
            userPermissions: action.data.user_group[0],
        });

    case actionCreator(LayoutTypes.GET_USER_DATA, 'err'):
        return Object.assign({}, state, {
            userData: {
                ...state.userData,
                loading: false,
                error: true,
            },
        });

    case LayoutTypes.LOAD_FAVORIS_ORDER:
        return Object.assign({}, state, {
            userData: {
                ...state.userData,
                loading: true,
                error: false,
            },
        });

    case actionCreator(LayoutTypes.LOAD_FAVORIS_ORDER, 'res'):
        return Object.assign({}, state, {
            userData: {
                ...state.userData,
                loading: false,
                data: { ...state.userData.data, favorite_orders: action.data },
            },
            userPermissions: action.data.user_group[0],
        });

    case actionCreator(LayoutTypes.LOAD_FAVORIS_ORDER, 'err'):
        return Object.assign({}, state, {
            userData: {
                ...state.userData,
                loading: false,
                error: true,
            },
        });

    case LayoutTypes.USER_LOGOUT:
        return Object.assign({}, state, {
            userData: {
                ...state.userData,
                operator: null,
                loading: true,
                error: false,
            },
            userToken: {
                ...state.userToken,
                loading: true,
                error: false,
            },
        });

    case actionCreator(LayoutTypes.USER_LOGOUT, 'res'):
        return Object.assign({}, state, {
            planningNavigationDate: null,
            userData: initState.userData,
            userToken: initState.userData,
            userPermissions: initState.userPermissions,
        });

    case actionCreator(LayoutTypes.USER_LOGOUT, 'err'):
        return Object.assign({}, state, {
            userData: {
                ...initState.userData,
                loading: false,
                error: true,
            },
            userToken: {
                ...initState.userToken,
                loading: false,
                error: true,
            },
            userPermissions: initState.userPermissions,
        });

    case LayoutTypes.EDIT_PROFILE:
        return Object.assign({}, state, {
            userData: {
                ...state.userData,
                loading: true,
                error: false,
            },
        });

    case LayoutTypes.USER_DATA_REFRESH:
        return Object.assign({}, state, {
            userData: {
                ...state.userData,
                loading: true,
                error: false,
            },
        });

    case actionCreator(LayoutTypes.USER_DATA_REFRESH, 'res'):
        return Object.assign({}, state, {
            userData: {
                ...state.userData,
                loading: false,
                data: action.data,
            },
        });

    case actionCreator(LayoutTypes.USER_DATA_REFRESH, 'err'):
        return Object.assign({}, state, {
            userData: {
                ...state.userData,
                loading: false,
                error: true,
            },
        });

    case LayoutTypes.LOAD_PARTNERS_LAYOUT:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(LayoutTypes.LOAD_PARTNERS_LAYOUT, 'res'):
        return Object.assign({}, state, {
            loading: false,
            partners: action.data,
        });

    case actionCreator(LayoutTypes.LOAD_PARTNERS_LAYOUT, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case LayoutTypes.LOAD_RESELLERS_LAYOUT:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(LayoutTypes.LOAD_RESELLERS_LAYOUT, 'res'):
        return Object.assign({}, state, {
            loading: false,
            resellers: action.data,
        });

    case actionCreator(LayoutTypes.LOAD_RESELLERS_LAYOUT, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case LayoutTypes.SET_OPERATOR_MACHINE:
        return Object.assign({}, state, {
            userData: {
                ...state.userData,
                operator: action.data,
            },
        });

    case LayoutTypes.SET_NAVIGATION_DATE:
        return Object.assign({}, state, {
            planningNavigationDate: action.data,
        });

    case LayoutTypes.INIT_GLOBAL_SEARCH:
        return Object.assign({}, state, {
            search: initState.search,
        });

    case LayoutTypes.SET_GLOBAL_SEARCH_SECTION_TAB:
        return Object.assign({}, state, {
            search: {
                ...state.search,
                tab: action.tab,
            },
        });

    case LayoutTypes.SET_GLOBAL_SEARCH_SECTION_COUNT:
        return Object.assign({}, state, {
            search: {
                ...state.search,
                counts: {
                    ...state.search.counts,
                    ...action.data,
                },
            },
        });

    case LayoutTypes.SET_RESELLER_FOR_TRANSLATIONS:
        return Object.assign({}, state, {
            translationResellerId: action.id,
        });

    default:
        return state;
    }
}
